export const SEARCH_TEXT = "SEARCH_TEXT";
export const SEARCH_TEXT_RESET = "SEARCH_TEXT_RESET";
export const SEARCH_OFFERS = "SEARCH_OFFERS";
export const SEARCH_OFFER_TEXT_RESET = "SEARCH_OFFER_TEXT_RESET";

